// MobileNavbar.jsx
import { ELEMENT_IDS } from "constants/constants";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

export default function MobileNavbar({
    filteredNavbarItems,
    location,
    // user,
    handleNotificationPress,
    handleLogOutPress,
    setLogInOptions,
    setSignUpOptions,
}) {
    // console.log({ filteredNavbarItems })
    const {
        user,
    } = useSelector((state) => state.auth);
    const isLogin = user !== null;


    return (
        <div
            // className={` ${(false) ? "d-flex d-md-none" : "d-none"}`}
            className={`${isLogin ? "tw-block" : "tw-hidden"}  sm:tw-hidden 
            tw-fixed sm:tw-absolute 
            tw-right-auto sm:tw-right-[15px] 
            tw-top-auto sm:tw-top-[65px] 
            tw-bottom-0 sm:tw-bottom-auto
            tw-bg-white 
            tw-z-[110] 
            tw-px-[10px] --tw-pt-[45px] --tw-pb-[45px]
            --tw-rounded-lg
            tw-shadow-[0_10px_20px_rgb(0_0_0_/_12%),0_2px_10px_rgb(0_0_0_/_7%)]
            --tw-h-[430px] 
            tw-w-full sm:tw-w-[300px] 
            tw-list-none
            `}
            id="navbarSupportedContentMobile"
        >
            <div className="nav-box tw-w-full
            tw-flex tw-justify-around tw-items-center tw-h-[70px] tw-m-0 tw-p-0 tw-list-none
            ">
                {/* Menu chung */}
                {filteredNavbarItems.map((navbarItem) => {
                    const isActive = location.pathname === navbarItem.link;

                    return (
                        <li key={`nav-${navbarItem.label}`}
                            className={`tw-relative tw-flex-1 tw-h-full tw-flex tw-flex-col tw-items-center tw-justify-center`}>
                            {/* ${isActive ? "tw-border-t-2 tw-border-[#549A9C]" : ""} */}
                            {isActive && <div className="tw-absolute tw-top-0 tw-h-[2px] tw-w-full tw-bg-[#549A9C] tw-rounded-b-[24px]" />}
                            <Link
                                to={navbarItem.link}
                                className={`
                  tw-h-full tw-flex tw-flex-col tw-justify-center tw-text-sm
                  ${isActive ? "tw-text-primary" : "tw-text-gray-600"}
                `}
                            >
                                {/* icon */}
                                <div className="tw-w-6 tw-h-6 tw-ml-auto tw-mr-auto tw-mb-1">
                                    {navbarItem.icon ? (
                                        <>{isActive ? navbarItem.iconActive : navbarItem.icon}</>
                                    ) : (
                                        <span className="tw-inline-block tw-w-6 tw-h-6 tw-bg-gray-300 tw-rounded" />
                                    )}
                                </div>
                                <span className="tw-mt-1 tw-ml-auto tw-mr-auto max-[390px]:tw-text-[12px] tw-text-[14px]">{navbarItem.label}</span>
                            </Link>
                        </li>
                    )
                })}

                {/* Nếu user đã login */}
                {isLogin ? (
                    <div className="tw-hidden">
                        <Link onClick={handleNotificationPress}>
                            <li>Notifications</li>
                        </Link>

                        {user?.role === "1" ? (
                            <>
                                <Link to="/creatorsSetting">
                                    <li>Settings</li>
                                </Link>
                                <Link to="/creatorsProfile">
                                    <li>Profile</li>
                                </Link>
                            </>
                        ) : (
                            <>
                                <Link to="/brandSetting">
                                    <li>Settings</li>
                                </Link>
                                <Link to="/brandProfile">
                                    <li>Profile</li>
                                </Link>
                            </>
                        )}

                        <Link onClick={handleLogOutPress}>
                            <li className="text-danger border-0 text-center pt-2">
                                Logout
                            </li>
                        </Link>
                    </div>
                ) : (
                    // Nếu chưa login
                    <div className="text-center mt-5 mx-4">
                        <div
                            id={ELEMENT_IDS.BTN_LOG_IN_FROM_LP}
                            data-bs-toggle="modal"
                            data-bs-target="#logInModal"
                            onClick={() => setLogInOptions(true)}
                        >
                            <button className="tw-bg-primary tw-w-full tw-text-white tw-font-semibold tw-py-3 tw-rounded-lg">
                                Login
                            </button>
                        </div>
                        <div className="my-2">OR</div>
                        <div
                            id={ELEMENT_IDS.BTN_SIGN_UP_FROM_LP}
                            data-bs-toggle="modal"
                            data-bs-target="#signUpModal"
                            onClick={() => setSignUpOptions(true)}
                        >
                            <button className="tw-bg-white tw-w-full tw-text-primary tw-border tw-border-primary tw-font-semibold tw-py-3 tw-rounded-lg">
                                Sign up
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
